<script setup lang="ts">
  export interface HistoryRevisionItem {
    revision: number;
    dateLabel: string;
    changes: string[];
  }

  withDefaults(
    defineProps<{
      items: HistoryRevisionItem[];
      emptyMessage?: string;
    }>(),
    {
      emptyMessage: undefined,
    }
  );
</script>

<template>
  <p
    v-if="items.length === 0 && emptyMessage"
    class="py-12 text-center text-sm text-gray-07"
    data-testid="history-empty"
  >
    {{ emptyMessage }}
  </p>
  <div v-else class="divide-y divide-gray-02">
    <div v-for="item in items" :key="item.revision" class="revision-section py-6">
      <h3 class="font-semibold text-gray-800 mb-3 revision-title">
        REV. {{ item.revision }} - {{ item.dateLabel }}
      </h3>
      <ul class="space-y-2">
        <li v-for="(change, index) in item.changes" :key="index" class="change-item">
          <span class="text-sm text-gray-700">• {{ change }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
